module.exports = __webpack_public_path__ + "img/orange.1bf98f9a.svg";